import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { LocalPlansType } from "@/types/PlansType";
import { Action, Getter } from "vuex-class";
import { CouponType } from "@/types/CouponTypes";
import { PromotionLabelType } from "@/types/FirebaseTypes";
import { ActionMethod } from "vuex";
import { homeTagEvents } from "@/helpers/Gtm/gaExecuteEvents";
import { tagNamePlan } from "@/helpers/TagNamePlanHelper";

@Component({
  name: "CardPlanMixin",
})
export class CardPlanMixin extends Vue {
  @Prop() plan!: LocalPlansType;
  @Prop({ default: true }) readonly opt!: boolean;
  @Prop({ default: 0 }) readonly instance!: number;
  @Prop({ default: null }) readonly path!: string;
  @Prop({ default: false }) readonly lock!: boolean;
  @Prop({ default: true }) readonly editCupom!: boolean;
  @Prop({ default: false }) readonly cupom!: boolean;
  @Getter tiktok!: string[];
  @Getter coupons!: CouponType[];
  @Getter skeeloCompositionId!: string[];
  @Getter getPromotionLabel!: PromotionLabelType;
  @Action checkCupom!: ActionMethod;
  open = false;
  off = "";
  showAlertMessage = false;
  internet = "";
  tag = "";
  price = "";
  discounts = "";
  valorBonus = "";
  id = "";
  paramBonus = false;
  couponOff = false;
  info = false;
  couponSelected = "";
  cupomType = "";

  mountPlanTitle(plan: any) {
    const planValue = plan.price;
    const planDiscount = this.discounts;
    const planFinalValue = this.off;
    const planDescription = `${plan.franchise || 0}GB de internet + ${
      plan.bonus || 0
    }GB de bônus`;

    const strPlan = String(
      this.$t("accessibilityTexts.title.cardPlan.wantThis")
    );

    if (
      String(planDescription) !== "" &&
      String(planValue) !== "" &&
      planDiscount !== "" &&
      planFinalValue !== ""
    ) {
      const planData = [
        planDescription,
        String(planValue).replace(".", ","),
        planFinalValue.replace(".", ","),
        planDiscount.replace(".", ","),
      ];

      let newString = strPlan;

      planData.forEach((str) => {
        newString = newString.replace("%", str);
      });

      return newString;
    }
    return "";
  }

  openInfo(plan: any): void {
    const win = window as any;
    if (this.info) {
      this.info = false;
      if (plan.id === "736df6a5-cb49-436c-bd5d-4255e2b007ba") {
        if (this.$gtm.enabled()) {
          win.dataLayer.push({
            event: "event",
            eventCategory: "claro-flex:home",
            eventAction: "clique:botao",
            eventLabel: "skeelo:16gb-mes-com-skeelo-padrao",
          });
        }
      }
      if (plan.id === "0b54bed4-1881-4d63-bf67-a88fbc3e04bc") {
        if (this.$gtm.enabled()) {
          win.dataLayer.push({
            event: "event",
            eventCategory: "claro-flex:home",
            eventAction: "clique:botao",
            eventLabel: "skeelo:10gb-mes-com-skeelo-padrao",
          });
        }
      }
      if (plan.id === "929d4daa-b0cb-4be9-9eba-10ba530c2535") {
        if (this.$gtm.enabled()) {
          win.dataLayer.push({
            event: "event",
            eventCategory: "claro-flex:home",
            eventAction: "clique:botao",
            eventLabel: "skeelo:08gb-mes-com-skeelo-light",
          });
        }
      }
    } else {
      this.info = true;
    }
  }

  format(num: any) {
    let v = num.replace(/\D/g, "");
    v = Number(v) / 100;
    v = v.toFixed(2);
    return v;
  }

  getLabelName() {
    const self = this as any;
    return self.plan.tag;
  }

  get isPromotionActive(): boolean {
    return (
      this.getPromotionLabel.active &&
      !!this.getPromotionLabel.plans?.find((p) => p.id === this.plan.id)
    );
  }

  get renderPromotionLabel(): string {
    const data = this.getPromotionLabel.plans?.find(
      (p) => p.id === this.plan.id
    );
    return data ? data.label : "";
  }

  onSuccessCupom({ discounts, code, rescueType }: CouponType) {
    const vl = this.plan.price;
    this.off = (vl - this.format(String(discounts[0].value.amount))).toFixed(2);
    this.discounts = this.format(String(discounts[0].value.amount));
    this.couponSelected = code;
    this.cupomType = rescueType;
    if (window.dtrum) {
      const idAction = window.dtrum.enterAction(
        "TROCA DE CUPOM: ".concat(this.couponSelected)
      );
      window.dtrum.leaveAction(idAction);
    }
  }

  openDetails(plan: LocalPlansType): void {
    homeTagEvents({
      custom_title: `clique-${tagNamePlan({
        bonus: String(this.plan.bonus),
        franchise: String(this.plan.franchise),
      })}:mais-detalhes`,
    });

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:botao",
        eventLabel: "mais-detalhes:".concat(String(plan.price)),
      });
    }
    const dataLayerPlans: any = [];
    dataLayerPlans.push({
      name: this.getLabelName(),
      id: this.plan.id,
      price: this.plan.price,
      brand: "claro-movel",
      category: "plano/celular/flex",
      variant: "migracao",
    });

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "productDetail",
        eventCategory: "claro-flex:enhanced-ecommerce",
        eventAction: "product-detail",
        noInteraction: "1",
        ecommerce: {
          detail: {
            products: dataLayerPlans,
          },
        },
      });
    }
    function onChangeTag(name: any, isGtm: boolean) {
      if (isGtm) {
        window.dataLayer?.push({
          event: "event",
          eventCategory: `claro-flex:${name}`,
          eventAction: "clique:botao",
          eventLabel: `mais-detalhes:mais-detalhes-${String(plan.price)}`,
        });
      }
    }

    switch (this.path) {
      case "cadastro-dados":
        onChangeTag("cadastro-dados", this.$gtm.enabled());
        break;
      case "cadastro-endereco":
        onChangeTag("cadastro-endereco", this.$gtm.enabled());
        break;
      case "cadastro-telefone":
        onChangeTag("cadastro-telefone", this.$gtm.enabled());
        break;
      case "cadastro-pagamento":
        onChangeTag("cadastro-pagamento", this.$gtm.enabled());
        break;
      case "cadastro-sucesso":
        onChangeTag("cadastro-sucesso", this.$gtm.enabled());
        break;
      default:
        break;
    }

    this.$emit("showModalDescription", {
      show: true,
      plan: this.plan,
    });
  }

  closeModal(): void {
    const win = window as any;

    const self = this as any;

    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:botao",
        eventLabel: "ok-entendi:".concat(self.plan.tag),
      });
    }

    this.showAlertMessage = false;
  }

  created() {
    const self = this as any;
    self.couponOff = this.cupom;

    if (self.couponOff) {
      this.off = self.plan.price.replace(".", ",");
    }
  }
}
